// extracted by mini-css-extract-plugin
export default {"layout":"auth-page_layout__5nLlx","box":"auth-page_box__aUJxB"};